import React from 'react';
import Button from "./Button";

const PrimaryButton = ({title, icon, fill, type, disabled, onClick}) => {
    return (
        <Button classType="Primary" title={title} icon={icon !== undefined && icon} fill={fill} type={type} disabled={disabled} onClick={onClick} />
    );
};

export default PrimaryButton;